import useBindActionCreators from 'common/hooks/useBindActionCreators';

import { reportsOperations } from '../store';

export const useReportsOperations = (): typeof reportsOperations => {
  const bindedActions = useBindActionCreators(reportsOperations);
  return bindedActions;
};
